import { Track, TrackPublication } from 'livekit-client';
import { useVideoLoadingState } from 'hooks/useVideoLoadingState';

interface UseVideoRenderLogicOptions {
    isShowVideo: boolean;
    track?: Track;
    cameraPublication?: TrackPublication;
    participantId: string;
}

interface VideoRenderState {
    isVideoReady: boolean;
    isVideoLoading: boolean;
    snapshot: string | null;
    shouldShowSnapshotInsteadOfAvatar: boolean;
    hasCameraEnabled: boolean;
}

export const useVideoRenderLogic = ({
    isShowVideo,
    track,
    cameraPublication,
    participantId,
}: UseVideoRenderLogicOptions): VideoRenderState => {
    const hasCameraEnabled = Boolean(cameraPublication && !cameraPublication.isMuted);

    const { isVideoLoading, isVideoReady, snapshot } = useVideoLoadingState({
        isShowVideo,
        isCameraEnabled: hasCameraEnabled,
        track,
        participantId,
    });

    const shouldShowSnapshotInsteadOfAvatar = Boolean(snapshot && hasCameraEnabled && !isVideoReady);

    return {
        isVideoReady,
        isVideoLoading,
        snapshot,
        shouldShowSnapshotInsteadOfAvatar,
        hasCameraEnabled,
    };
};
